import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import CanTabing from '../../../component/CanTabing';
import Breadcrumb from '../../../component/Breadcrumb';
import PageTabing from '../../../component/PageTabing';
import {Button, Box, Grid, Typography } from '@mui/material';
import ConstantRows from './rows';
import MappingTabing from '../../../component/MappingTabing';
import CanMappingTabing from '../../../component/CanMappingTabing';
import swal from 'sweetalert';
import { checklocalStorageItems, saveContentFile } from '../../../utlis';
import Loader from '../../../component/Loader/Loader';

const ECUConstantTxMessages = () => {
    const [showLoader, setShowLoader] = useState(false);
    const [itemForLocal, setItemForLocal]   = useState(false);
    const [rows,setRows] = useState({});
    const location = useLocation();
    
    useEffect(() => {
        const dataInLocalStorage = checklocalStorageItems();
        setItemForLocal(dataInLocalStorage);
        getFetchFieldsData();
    },[]);

    const getFetchFieldsData = () => {
        let existingConstantMessages= JSON.parse(localStorage.getItem('ECUConstantTxMessages'));
        if(existingConstantMessages != null && existingConstantMessages.length > 0){
            setRows(existingConstantMessages);
        }
    }

    const handleRowDelete = (rowIndex) => {
        const newArray = [...rows];
        newArray.splice(rowIndex, 1);
        setRows(newArray);
        if(newArray.length === 0){
            localStorage.removeItem("ECUConstantTxMessages");
        } else {
            localStorage.setItem('ECUConstantTxMessages',JSON.stringify(newArray));
        }
    }
    
    const handleConfigFileContent = async() => {
        setShowLoader(true);
        const result = await saveContentFile();
        setShowLoader(false);
        if(result){
            swal({
              title: "Success",
              text: result.message,
              icon: "success",
            })
        }
    }


    return (
        <>
            {showLoader && 
                <Loader />
            }
            <Breadcrumb  title="ECU Constant TxMessages">
                <Typography component={Link} to="/" variant="subtitle2" color="primary" className="link-breadcrumb">
                Dashboard
                </Typography>
                <Typography variant="subtitle2" color="inherit" className="link-breadcrumb">
                CAN
                </Typography>
            </Breadcrumb>
            {location.pathname.includes('mapping') &&
                <MappingTabing 
                    value="can" 
                    handleConfigFileContent={handleConfigFileContent}      
                />
            }
            {!location.pathname.includes('mapping') &&
                <PageTabing value="can" />
            }
            <Box  component="section">
                <Grid className="contentBox">
                    {location.pathname.includes('mapping') &&
                        <CanMappingTabing value="constant-messages" />
                    }
                    {!location.pathname.includes('mapping') &&
                        <CanTabing value="constant-messages" />
                    }
                    {(!location.pathname.includes('mapping') || itemForLocal) &&
                        <Grid className="modbusButtons" container direction="row" display={'flex'} justifyContent={'flex-end'}>
                            <Grid item>
                                <Button
                                    //onClick={handleClickOpen}
                                    component={Link} 
                                    to={location.pathname.includes('mapping') ? '/mapping/can/constant-messages/new' : '/can/constant-messages/new'}
                                    variant="contained"
                                    size="small"
                                    color="primary"
                                    sx={{mr:3}}
                                >Add New 
                                </Button>
                            </Grid>
                        </Grid>
                    }
                    {rows.length === 0  &&
                        <p>No Data Available.</p>
                    }
                    {rows?.length > 0 &&
                        <ConstantRows 
                            data={rows}
                            handleRowDelete={handleRowDelete}
                        />
                    }
                </Grid>
            </Box>
        </>
    )
};

export default ECUConstantTxMessages;
